import { KorisnikLoginResponse } from "app/api/uk-api-reference";

export class Login {
    static type = '[Auth] Login';
    constructor(public username: string, public password: string) { }
}

export class LoginSuccess {
    static type = '[Auth] LoginSuccess';
    constructor(public data: KorisnikLoginResponse, public isRefresh: boolean) { }
}

export class LoginOauthSuccess {
    static type = '[Auth] LoginOauthSuccess';
    constructor(public data: KorisnikLoginResponse, public isRefresh: boolean) { }
}

export class GetToken {
    static type = '[Auth] GetToken';
}

export class Logout {
    static type = '[Auth] Logout';
    constructor(public noRedirectToUrl: boolean) { }
}

export class PageRefreshTokenRefresh {
    static type = '[Auth] PageRefreshTokenRefresh';
}

export class LoginFailed {
    static type = '[Auth] LoginFailed';
    constructor(public error: any) { }
}